// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLanguages } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { CustomAppState } from "@stoneage/App/Store/Reducers";

export function xngHasChanges(state: CustomAppState) {
    const {
        accountSettings: {
            editingAccount,
            initialUseDefaultCustomer,
            useDefaultCustomer,
            initialShipToId,
            selectedShipToId,
        },
    } = state.pages;
    const account = getCurrentAccountState(state).value;
    if (
        !account ||
        !editingAccount ||
        state.xAccountSettings.phoneError.length ||
        !state.xAccountSettings.firstName.length ||
        !state.xAccountSettings.lastName.length ||
        !state.xAccountSettings.properties.phone.length
    ) {
        return false;
    }

    return (
        account.email !== editingAccount.email ||
        account.setDefaultCustomer !== editingAccount.setDefaultCustomer ||
        account.isSubscribed !== editingAccount.isSubscribed ||
        account.defaultFulfillmentMethod !== editingAccount.defaultFulfillmentMethod ||
        account.defaultWarehouseId !== editingAccount.defaultWarehouseId ||
        useDefaultCustomer !== initialUseDefaultCustomer ||
        initialShipToId !== selectedShipToId ||
        account.firstName !== state.xAccountSettings.firstName ||
        account.lastName !== state.xAccountSettings.lastName ||
        state.xAccountSettings.properties.phone !== account.properties.phone ||
        (state.xAccountSettings.properties.language.length &&
            state.xAccountSettings.properties.language !== account.properties.language)
    );
}

export function getUserDataForMarketoForm(state: CustomAppState | ApplicationState) {
    const accountLanguageId = getCurrentAccountState(state)?.value?.properties["language"];
    const languages = getLanguages(state);
    const billToId = state.context.session.billToId;
    const currentBillTo = state.data.billTos.byId?.[billToId || ""];

    let currentLanguage = state.context.session.language?.description;
    if (accountLanguageId && languages) {
        currentLanguage = languages.filter(lang => lang.id === accountLanguageId)?.[0].languageCode;
    }
    return {
        isAuthenticated:
            (state.context.session.isAuthenticated || state.context.session.rememberMe) &&
            !state.context.session.isGuest,
        currentCurrency: state.context.session.currency?.currencyCode,
        currentLanguage,
        firstName: state.context.session.firstName,
        lastName: state.context.session.lastName,
        email: state.context.session.email,
        phone: state.context.session.properties?.["phone"],
        country: currentBillTo?.country?.name,
        state: currentBillTo?.state?.abbreviation,
        company: currentBillTo?.companyName,
    };
}
